import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const skeletons: TSkeletons = Array.from({ length: 5 }, () => ({
  className: 'productsCatalogSlider__skeletonSlide',
}))
